import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    EmptyState,
    BaasicButton,
    BaasicModal,
    NumericInput
} from "core/components";
import { PageLayout, Content } from "core/layouts";
import { FacilityInventoryCountDetailEdit } from "application/facility-inventory/pages";
import { FacilityInventoryCountEdit } from "application/facility-inventory/components";
import { observer } from "mobx-react";

const FacilityInventoryCountDetailListTemplate = function ({ facilityInventoryCountDetailListViewStore }) {

    const {
        contentLoading,
        loadingData,
        authorization,
        onCreate,
        isCreate,
        isDone,
        convertCaseToEachItems,
        // goToFacilityInventoryCountImport,
        editModal,
        facilityInventoryCountDetails,
        editItem,
        updateQuantity,
        facilityInventoryCountDetailsRowRefs,
        editResource,
        deleteResource,
        newDownloadUrl,
        goToFacilityInventoryCountImport
    } = facilityInventoryCountDetailListViewStore;
    const importButton = (
        <React.Fragment>
            <BaasicButton
                className="btn btn--base btn--primary"
                label="Convert"
                onClick={() => { convertCaseToEachItems() }}
                disabled={isDone}/>
            <BaasicButton
                authorized={authorization.update}
                className="btn btn--base btn--primary"
                label={'Upload'}
                icon='u-icon u-icon--sml u-icon--upload--white'
                disabled={isDone}
                onClick={() => goToFacilityInventoryCountImport()}>
            </BaasicButton>
            {/* {downloadUrl && <a className="btn btn--base btn--primary" href={downloadUrl}><i className="u-icon u-icon--sml u-icon--download--white"></i>Download</a>} */}
            {newDownloadUrl && <a className="btn btn--base btn--primary" href={newDownloadUrl}><i className="u-icon u-icon--sml u-icon--download--white"></i>Download</a>}

        </React.Fragment>);

    return (
        <PageLayout store={facilityInventoryCountDetailListViewStore} onCreate={onCreate} navigationItem={importButton}>
            <Content emptyRenderer={renderEmpty()} loading={contentLoading || loadingData}>
                {authorization && !isDone &&
                    <div className="u-mar--top--med">
                        <FacilityInventoryCountDetailEdit onCreate={onCreate} isCreate={isCreate} />
                    </div>
                }
                <div className="card--primary card--med u-mar--top--med">
                    <FacilityInventoryCountDetailsTable
                        facilityInventoryCountDetails={facilityInventoryCountDetails}
                        editItem={editItem}
                        facilityInventoryCountDetailsRowRefs={facilityInventoryCountDetailsRowRefs}
                        updateQuantity={updateQuantity}
                        isDone={isDone}
                        editResource={editResource}
                        deleteResource={deleteResource}
                    />
                </div>
                <BaasicModal modalParams={editModal} className="modal__content modal--sml">
                    <FacilityInventoryCountEdit />
                </BaasicModal>
            </Content>
        </PageLayout>
    );
};

function renderEmpty() {
    return (
        <EmptyState
            title="FACILITY_INVENTORY.LIST.EMPTY_STATE.TITLE"
        />
    );
}

// Develop wrapped this class with `@observer`; the mobx-undecorate
// codemod stripped the decorator without converting to the new
// `observer(Component)` call form, so the table stopped subscribing
// to the observables it reads. Restore the wrap.
const FacilityInventoryCountDetailsTable = observer(class FacilityInventoryCountDetailsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    selectValue = (e) => e.target.select();

    render() {
        const { facilityInventoryCountDetails, editItem, updateQuantity, facilityInventoryCountDetailsRowRefs, isDone, editResource, deleteResource } = this.props;
        return (
            <table className="table--preview">
                <thead>
                    <tr>
                        <th className="type--left">Item Id</th>
                        <th width="40%"  className="type--left">Item Name</th>
                        <th width="14%" className="type--left">Case QTY</th>
                        <th width="14%" className="type--left">Each QTY</th>
                        <th width="14%"className="type--left">Total Each QTY</th>
                        {!isDone ? <th width="5%" className="type--right">Actions</th>
                            :
                            ""
                        }
                    </tr>
                </thead>
                <tbody>
                    {facilityInventoryCountDetails.map((item, index) => {
                        return (<tr key={item.id} ref={(ref) => { facilityInventoryCountDetailsRowRefs[index] = ref; return true; }}>
                            <td className="c-pointer table--clickable" onClick={(e) => {
                                e.stopPropagation();
                                if (!isDone)
                                    editResource(item);

                            }}>
                                {item.product && item.product.itemId}
                            </td>
                            <td className="c-pointer table--clickable" onClick={(e) => {
                                e.stopPropagation();
                                if (!isDone)
                                    editResource(item);
                            }}>
                                {item.product && item.product.description}
                            </td>
                            <td style={{ padding: "0px" }}>
                                <NumericInput
                                    value={item.caseQty}
                                    disabled={isDone}
                                    showLabel={false}
                                    onChange={(e) => {
                                        editItem(index, e.target.value, 'caseQty');
                                    }}
                                    onBlur={(e) => {
                                        updateQuantity(item.id, index, e.target.value, 'caseQty');
                                    }}
                                    max={"999.99"}
                                    min={"0"}
                                />	</td>
                            <td style={{ padding: "0px" }}>
                                <NumericInput
                                    value={item.eachQty}
                                    disabled={isDone}
                                    showLabel={false}
                                    onChange={(e) => {
                                        editItem(index, e.target.value, 'eachQty');
                                    }}
                                    onBlur={(e) => {
                                        updateQuantity(item.id, index, e.target.value, 'eachQty');
                                    }}
                                    max={"999.99"}
                                    min={"0"}
                                />
                            </td>
                            <td>
                                {item.quantity}
                            </td>
                            {!isDone ?
                                <td className="table-col-input type--right">
                                    <BaasicButton
                                        className="btn btn--icon is-delete"
                                        icon="u-icon u-icon--delete u-icon--sml"
                                        label="Delete"
                                        onlyIcon={true}
                                        onClick={() => deleteResource(item)}
                                    />
                                </td> : ""
                            }
                        </tr>);
                    }
                    )}
                </tbody>
            </table>
        );
    }
});

FacilityInventoryCountDetailsTable.propTypes = {
    facilityInventoryCountDetails: PropTypes.object,
    editItem: PropTypes.func,
    facilityInventoryCountDetailsRowRefs: PropTypes.array,
    updateQuantity: PropTypes.func,
    editResource: PropTypes.func,
    deleteResource: PropTypes.func,
    isDone: PropTypes.bool
};

FacilityInventoryCountDetailListTemplate.propTypes = {
    facilityInventoryCountDetailListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityInventoryCountDetailListTemplate);